<template>
  <div>
    <table-view
      ref="tableList"
      :isSearchLoading="isAllLoad"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="page"
      @pageChange="pageChange"
      @searchChange="handleSearchChange"
      tableCardTitle="CREDIT REQUEST"
      :isSearchRow="false"
      :isTableLoading="isTableLoading"
    >
      <template v-slot:bpmId="{ tableRow }">
        <a href="javascript:void(0)" @click="handleHrefInfoPage(tableRow.row)">
          {{ tableRow.row.bpmId }}
        </a>
      </template>
    </table-view>
  </div>
</template>

<script>
import { getTableList, getCssDetail } from './api'
import { getSelectList } from '@/api'

const selectList = ['Country', 'Region', 'CCA', 'Business']
const STATUS = [
  { id: 1, name: 'Pending' },
  { id: 2, name: 'Manual Approved' },
  { id: 3, name: 'Declined' },
  { id: 4, name: 'Cancelled' },
  { id: 6, name: 'Conditional Approval' },
  { id: 8, name: 'Field Action' },
]
export default {
  name: 'query',
  data() {
    const searchModel = [
      { label: 'Trans#', type: 'input', key: 'bpmId' },
      { label: 'Customer#', type: 'input', key: 'companyCode' },
      { label: 'Customer Name', type: 'input', key: 'companyName' },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        selectList: [
          { id: 1, name: 'Pending' },
          { id: 2, name: 'Manual Approved' },
          { id: 3, name: 'Declined' },
          { id: 4, name: 'Cancelled' },
          { id: 5, name: 'Waiting Auto Rules' },
          { id: 7, name: 'Auto Approved' },
        ],
      },
      {
        label: 'Transaction Date',
        type: 'time',
        key: 'time',
        defaultValue: [],
      },
    ]
    const tableModel = [
      { slotName: 'bpmId', label: 'Trans#' },
      { prop: 'companyCode', label: 'Customer#' },
      { prop: 'companyName', label: 'Customer Name' },
      { prop: 'approver', label: 'Assigned To' },
      // { prop: 'priorityStr', label: 'Priority' },
      { prop: 'applyDate', label: 'Transaction Date' },
      { prop: 'region', label: 'Region' },
      { prop: 'source', label: 'Source' },
      { prop: 'statusStr', label: 'Status' },
    ]
    return {
      isTableLoading: true,
      searchModel,
      tableModel,
      tableData: [],
      page: {
        pageSize: 10,
      },
      selectType: 'Region',
      isAllLoad: true,
    }
  },
  created() {
    // 获取下拉列表
    this.getAllSelect()
  },
  mounted() {
    this.initTable()
    this._getSelectList(this.selectType)
  },
  methods: {
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableList({ ...params, size: 10 })
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [countryList, regionList, ccaList, businessList] = res
            for (let i = 0; i < this.searchModel.length; i++) {
              const item = this.searchModel[i]
              if (item.label === 'Region') {
                item['selectList'] = regionList
              } else if (item.label === 'Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.label === 'Business') {
                item['selectList'] = businessList
              }
            }
            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.log(`search 列表查询错误:${err}`)
        })
    },
    handleSearchChange(params) {
      params.current = 1
      params.size = 10
      this._getTableList(params)
    },
    async _getTableList(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getTableList(params)
        // 将source来源(1,2)显示改变
        if (this.$store.state.source === 1) {
          data.forEach(item => {
            item.source = 'lenovo'
          })
        } else {
          data.forEach(item => {
            item.source = 'CSS'
          })
          this.searchModel[3].selectList = STATUS
        }
        this.tableData = data
        this.page = page
        this.isTableLoading = false
      } catch (err) {
        console.log(err)
      }
    },
    async handleHrefInfoPage(tableRow) {
      this.$storage.setItem('bpmId', tableRow.bpmId)
      if (tableRow.source === 'CSS') {
        const params = {
          bpmId: tableRow.bpmId || this.$storage.getItem('bpmId'),
        }
        const { running, creditInfo, additionalConditionsVOList, process } =
          await getCssDetail(params)
        // 根据status跳转;1为pending状态(跳到final);2为完成; 6为condition approved状态(跳到二次审核)
        console.log(creditInfo.status)
        if ([6, 8].includes(creditInfo.status)) {
          // 二次审批
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-second-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}&status=${tableRow.status}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else if (
          (creditInfo.status === 1 &&
            additionalConditionsVOList.length === 0 &&
            process.length === 2) ||
          (creditInfo.decisionType === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1) ||
          (creditInfo.decisionType === 4 &&
            creditInfo.status === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1) ||
          running === 1
        ) {
          // 单比审批
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/single-audit?bpmId=${tableRow.bpmId}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else {
          // 最终审批
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-final-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        }
        return
      }
      // trade
      let routeUrl = this.$router.resolve({
        path: `/credit-management/credit-audit/single-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
    },
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.log(err)
      }
    },
    // 分页器页码改变
    pageChange(curPage) {
      const queryForm = {}
      const params = Object.assign({}, queryForm, {
        current: curPage.current,
        size: 10,
        status: curPage.status,
      })
      this._getTableList(params)
    },
    // goto audit
  },
}
</script>

<style scoped></style>
